import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Agenda from "@/pages/Agenda";
import Comparateur from "@/pages/Comparateur";
import Contrat from "@/pages/Contrat";
import Login from "@/pages/Login";
import Confidentialite from "@/pages/Confidentialite";
import Studio from "@/pages/Studio";

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/comparateur" element={<Comparateur />} />
          <Route path="/contrat" element={<Contrat />} />
          <Route path="/login" element={<Login />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/studio" element={<Studio />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
